import React, { useEffect, useState } from "react";
import { CreateTicketingApp } from "./CreateApp";
import { CheckoutSettingsTabs } from "./TicketeiraConfig";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import { getPaymentConfig } from "../../../utils/services/ticketeira";
import { Spinner } from "reactstrap";

const LayoutCreateTicketing = (props) => {
  const location = useLocation();
  const idEvent = location.state?.idEvent || "";
  const token = props.state.global_user_data.data.token;

  const [newRepository, setNewRepository] = useState("");
  const [subDomain, setNewSubDomain] = useState("");
  const [visible, setVisible] = useState(false);
  const [miceEventId, setMiceEventId] = useState("");
  const [plusEventIdDev, setPlusEventIdDev] = useState("");
  const [plusEventIdProd, setPlusEventIdProd] = useState("");
  const [successDlg, setSuccessDlg] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showDomains, setShowDomains] = useState(false);
  const [showInfo, setShowInfo] = useState(true);
  const [errors, setErrors] = useState({
    newRepository: "",
    subDomain: "",
    miceEventId: "",
    plusEventIdDev: "",
    plusEventIdProd: "",
  });

  const [isLoadingConfig, setIsLoadingConfig] = useState(false);

  const [formFields, setFormFields] = useState([
    {
      label: { pt: "" },
      type: "text",
      order: 1,
      required: false,
      error: { pt: "" },
    },
  ]);
  const [paymentConfig, setPaymentConfig] = useState(null);
  const [paymentMethods, setPaymentMethods] = useState({
    pix: false,
    creditCard: false,
  });
  const [headerImgUrl, setHeaderImgUrl] = useState(
    paymentConfig?.headerImgUrl || ""
  );
  const [description, setDescription] = useState("");
  const [details, setDetails] = useState("");
  const [activeTab, setActiveTab] = useState("1");

  const [error, setError] = useState(null);

  const fetchPaymentConfig = async () => {
    setIsLoadingConfig(true);
    try {
      const data = await getPaymentConfig(idEvent, token);
      setPaymentConfig(data);
    } catch (err) {
      setError(err);
    } finally {
      setIsLoadingConfig(false);
    }
  };

  useEffect(() => {
    fetchPaymentConfig();
  }, []);

  return (
    <main>
      {isLoadingConfig ? (
        <div style={{ textAlign: "center", padding: "2rem" }}>
          <Spinner color="primary" />
        </div>
      ) : paymentConfig ? (
        <CheckoutSettingsTabs
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          formFields={formFields}
          setFormFields={setFormFields}
          headerImgUrl={headerImgUrl}
          setHeaderImgUrl={setHeaderImgUrl}
          description={description}
          setDescription={setDescription}
          details={details}
          setDetails={setDetails}
          idEvent={idEvent}
          paymentMethods={paymentMethods}
          setPaymentMethods={setPaymentMethods}
          token={token}
          currentConfig={paymentConfig}
        />
      ) : (
        <CreateTicketingApp
          newRepository={newRepository}
          setNewRepository={setNewRepository}
          subDomain={subDomain}
          setNewSubDomain={setNewSubDomain}
          visible={visible}
          setVisible={setVisible}
          miceEventId={miceEventId}
          setMiceEventId={setMiceEventId}
          plusEventIdDev={plusEventIdDev}
          setPlusEventIdDev={setPlusEventIdDev}
          plusEventIdProd={plusEventIdProd}
          setPlusEventIdProd={setPlusEventIdProd}
          successDlg={successDlg}
          setSuccessDlg={setSuccessDlg}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          showDomains={showDomains}
          setShowDomains={setShowDomains}
          showInfo={showInfo}
          setShowInfo={setShowInfo}
          errors={errors}
          setErrors={setErrors}
          refetchPaymentConfig={fetchPaymentConfig}
          idEvent={idEvent}
          token={token}
        />
      )}
    </main>
  );
};

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps)(LayoutCreateTicketing);
